'use client'

import groupBy from 'lodash.groupby'
import React, { useEffect, useState } from 'react'
import { BrandListPageFragment } from '@contentsite/src/graphql/generated/graphql-types'
import Image from '@dustin-web/microsite-components/src/image'
import Breadcrumbs from '@dustin-web/microsite-components/src/breadcrumbs'
import { Accordion } from '@dustin-web/microsite-components'

const BrandList = (props: { page: BrandListPageFragment }) => {
  const page = props.page
  const brandsGroupedByFirstLetter =
    groupBy(page.brands, brand => brand.name.toUpperCase()[0]) || {}
  const [selectedGroup, setSelectedGroup] = useState<null | string>(null)

  useEffect(() => {
    const match = window.location.hash.match(/#(?<letter>[A-Z0-9])/)

    if (match?.groups?.letter) {
      setSelectedGroup(match.groups.letter)
    }
  }, [])

  const breadcrumbs = [
    {
      displayName: page.header,
      url: '',
      clientNavigationRoute: '',
    },
  ]

  return (
    <div className="u-bg-gray-02 u-pb-48">
      <div className="container">
        <Breadcrumbs path={breadcrumbs} />
        <h1 className="h2 u-pt-16 u-mb-32">{page.header}</h1>
        <div className="row">
          <div className="col-12 col-lg-10">
            {Object.entries(brandsGroupedByFirstLetter).map(([firstLetter, value]) => {
              const numberOfBrands = value?.length - 5

              return (
                <Accordion
                  key={firstLetter}
                  extState={true}
                  extOpen={firstLetter === selectedGroup}
                  title={
                    <div className="d-flex align-items-center u-pl-4 u-py-8">
                      <h2 id={firstLetter} className="u-fs-24 u-mr-32 u-mb-0 u-w-32">
                        {firstLetter}
                      </h2>

                      {value.slice(0, 5).map(brand => {
                        return (
                          brand.logo && (
                            <div className="u-mr-16 d-inline-block d-flex" style={{ opacity: 0.7 }}>
                              <Image src={brand.logo.relativeUrl} alt="" width="50" height="25" />
                            </div>
                          )
                        )
                      })}

                      <div className="p-sm">
                        {numberOfBrands > 5 && <span> + ({numberOfBrands})</span>}
                      </div>
                    </div>
                  }
                  noPanelPadding>
                  <div className="u-bg-gray-02 u-py-24 u-pl-40">
                    <div className="row sm-gutters">
                      {value.map(brand => {
                        return (
                          <div
                            className="col-4 col-sm-3 col-md-2 u-text-center u-mb-16"
                            style={{ minHeight: '95px' }}
                            key={brand.name}>
                            <a href={brand.url} className="c-box d-block u-h-100 a-stripped">
                              {brand.logo && (
                                <Image
                                  src={brand.logo.relativeUrl}
                                  alt={brand.name}
                                  width="70"
                                  height="55"
                                />
                              )}
                              <br />
                              {brand.name}
                            </a>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </Accordion>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BrandList
